import moment from "moment";
import { useEffect, useState } from "react";

// 倒计时组件
export const CountdownTimer = ({ deadline }) => {
    const [timeLeft, setTimeLeft] = useState("");

    useEffect(() => {
        const interval = setInterval(() => {
            const now = moment().utcOffset(8); // Current time, GMT+8
            const end = moment(deadline).utcOffset(8); // Deadline, GMT+8
            const duration = moment.duration(end.diff(now));

            if (duration.asSeconds() <= 0) {
                setTimeLeft("00 ngày 00:00:00"); // Fixed format when countdown ends
                clearInterval(interval); // Stop timer
            } else {
                const days = Math.floor(duration.asDays()); // Get whole days
                const hours = duration.hours().toString().padStart(2, "0");
                const minutes = duration.minutes().toString().padStart(2, "0");
                const seconds = duration.seconds().toString().padStart(2, "0");

                // Ensure days always have 2 digits
                const formattedDays = days >= 10 ? days : `0${days}`;

                setTimeLeft(
                    `${formattedDays} ngày ${hours}:${minutes}:${seconds}`
                );
            }
        }, 1000);

        return () => clearInterval(interval); // Cleanup timer on unmount
    }, [deadline]);

    return <span style={{ color: "#666666" }}>{timeLeft}</span>;
};


// Promotion item status Enum
export const promotionStatusMapping = [
    {
        type: "goApply",
        tagText: "Đăng ký ngay",
        tagCN: "立即申请",
        isButtonStyle: false,
        isDisabled: false,
        statusList: [
            { statusName: "APPLY_FORM", isNeedLogin: false },
            { statusName: "NO_FORM", isNeedLogin: false },
            { statusName: "FUND_IN", isNeedLogin: false },
            { statusName: "DEPOSIT_PAGE_ONLY", isNeedLogin: false },
            { statusName: "REQUIRED_LOGIN", isNeedLogin: false },
            { statusName: "READY_TO_ENROLL", isNeedLogin: true },
            // {statusName: "FUND_IN", isNeedLogin:true}, //測試用
        ],
    },
    {
        type: "reviewing",
        tagText: "Đang xem xét",
        tagCN: "审核中",
        isButtonStyle: true,
        isDisabled: true,
        statusList: [{ statusName: "PENDING_RESULT", isNeedLogin: true }],
    },
    {
        type: "readyToStart",
        tagText: "Bắt đầu khuyến mãi",
        btnText: "Bắt đầu khuyến mãi",
        tagCN: "符合资格",
        btnCN: "开始优惠",
        isButtonStyle: true,
        statusList: [{ statusName: "START_TO_CLAIM", isNeedLogin: true }],
    },
    {
        type: "applied",
        tagText: "Đã đăng ký",
        tagCN: "已申请",
        isButtonStyle: true,
        isDisabled: true,
        statusList: [{ statusName: "ALREADY_APPLIED", isNeedLogin: true }],
    },
    {
        type: "claimed",
        tagText: "Đã đăng ký",
        tagCN: "已领取",
        isButtonStyle: true,
        isDisabled: true,
        statusList: [{ statusName: "ALREADY_CLAIMED", isNeedLogin: true }],
    },
    {
        type: "noAction",
        tagText: "Đăng ký ngay",
        tagCN: "查看詳情",
        isButtonStyle: false,
        statusList: [{ statusName: "NO_ACTION", isNeedLogin: false }],
    },
    // tag不顯示此狀態，只用於TnC CTA btn
    {
        type: "notInPromotionPeriod",
        btnText: "ขอรับได้ภายในระยะเวลาที่กำหนด",
        btnCN: "仅限指定时段申请",
        isButtonStyle: false,
        isDisabled: true,
        statusList: [
            { statusName: "NOT_DURING_PERIOD", isNeedLogin: false }, //自創 statusName value
        ],
    },
];